module.exports = __webpack_public_path__ + "static-portal/img/3.c210245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.png
// module id = LHqX
// module chunks = 4